import cx from 'classnames'
import React, { useRef, useState } from 'react'
import { MdExpandMore } from 'react-icons/md'

import { useClickOutside } from '../../../../../hooks'
import { cancelledOrCompleted, prepareName } from '../../../utils'
import styles from '../select.module.scss'

export function Multi ({
  relation,
  handler,
  disabled,
  issues,
  itemId,
  selected,
  style,
  detail = false,
  onFocus,
  lists
}) {
  const [ isOpen, setOpen ] = useState(false)
  const wrapperRef = useRef(null)
  useClickOutside(wrapperRef, () => {
    setOpen(false)
  })
  if (relation.type === 'input') {
    return (
      <div
        className={cx(styles.itemsWrapper)}
        style={style}
      >
        <input
          value={selected?.value || ''}
          type='text'
          className={cx(styles.input, styles.comment)}
          disabled={disabled}
          placeholder={prepareName(relation.key)}
          onFocus={() => onFocus()}
          onChange={e =>
            handler({
              id: relation.id,
              key: relation.key,
              value: e.target.value,
              type: relation.type
            })}
        />
      </div>
    )
  }

  return (
    <div
      className={cx(styles.itemsWrapper)}
      style={style}
      ref={wrapperRef}
    >
      <div
        className={styles.typeSelect}
        data-role='type-select'
        style={style}
        onClick={() => {
          if (!disabled) setOpen(s => !s)
        }}
        aria-hidden='true'
      >
        <span className={styles.label}>
          {selected
            ? lists[selected.key].find(l => l.id === selected.id).name
            : prepareName(relation.key)}
        </span>
        <div style={{ width: '16px', height: '16px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <MdExpandMore height={16} />
        </div>
      </div>
      {lists[relation.key]?.length > 0 && (
        <div
          className={cx(styles.items, {
            [styles.hide]: !isOpen
          })}
          data-role='items'
        >
          {lists[relation.key].map(element => {
            const temp = issues?.find(
              iss =>
                iss?.relations?.find(
                  rel => rel.id === element?.id && element.name === rel.name
                ) && !cancelledOrCompleted(iss)
            )
            const unavailable = element?.unavailable
            return (
              (unavailable && !!temp) ||
              (!unavailable && (
                <div
                  key={element.id}
                  className={styles.selectItem}
                  onClick={() => {
                    if (!disabled || !unavailable) {
                      handler({
                        id: element.id,
                        key: relation.key,
                        parent: itemId,
                        detail,
                        type: relation.type
                      })
                      setOpen(false)
                    }
                  }}
                  aria-hidden='true'
                >
                  <div
                    className={cx(styles.text, {
                      [styles.unavailable]: unavailable
                    })}
                  >
                    {element.name.replaceAll('_', ' | ')}
                  </div>
                </div>
              ))
            )
          })}
        </div>
      )}
    </div>
  )
}
